var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title:
          "SOP" +
          _vm.$t("CargoMsg.Cargo_WorkNode") +
          _vm.$t("SeaExport.EditSopStatus"),
        width: "420px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        { attrs: { "label-width": "60px", "label-position": "right" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("CargoMsg.Cargo_CurrentNode") } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    disabled: true,
                    no: "trackingCode",
                    placeholder: _vm.$t("SeaExport.PleaseSelectANode")
                  },
                  on: { change: _vm.getTrackingDetail },
                  model: {
                    value: _vm.trackingCode,
                    callback: function($$v) {
                      _vm.trackingCode = $$v
                    },
                    expression: "trackingCode"
                  }
                },
                _vm._l(_vm.availableTrackingList, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.codeCname, value: item.code }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Sop.nodeState") } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    no: "trackingDetailCode",
                    placeholder: _vm.$t("SeaExport.PleaseSelectAState")
                  },
                  model: {
                    value: _vm.trackingDetailCode,
                    callback: function($$v) {
                      _vm.trackingDetailCode = $$v
                    },
                    expression: "trackingDetailCode"
                  }
                },
                _vm._l(_vm.trackingDetailList, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.codeCname, value: item.code }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("CargoMsg.Cargo_ProcessingTime") } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "340px" },
                attrs: {
                  no: "trackingDetailDate",
                  type: "datetime",
                  "value-format": "yyyy-MM-dd HH:mm",
                  format: "yyyy-MM-dd HH:mm",
                  placeholder: _vm.$t("SeaExport.SelectTime")
                },
                model: {
                  value: _vm.trackingDetailDate,
                  callback: function($$v) {
                    _vm.trackingDetailDate = $$v
                  },
                  expression: "trackingDetailDate"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("CargoMsg.Cargo_ProcessedBy") } },
            [
              _c("el-input", {
                attrs: {
                  disabled: true,
                  value: _vm.ColumnUtils.resolveColumnLabel(
                    _vm.selectTypeNames.basic_data_User,
                    "userId",
                    Number(_vm.$store.getters.userId),
                    "chineseName"
                  ),
                  no: "trackingUser"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  no: "trackingDetailRemark",
                  rows: 3
                },
                model: {
                  value: _vm.trackingDetailRemark,
                  callback: function($$v) {
                    _vm.trackingDetailRemark = $$v
                  },
                  expression: "trackingDetailRemark"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: " " } },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { no: "messageChecked" },
                  model: {
                    value: _vm.messageChecked,
                    callback: function($$v) {
                      _vm.messageChecked = $$v
                    },
                    expression: "messageChecked"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Message.SendStatusChangeNotification")))]
              )
            ],
            1
          ),
          _c("el-form-item", { attrs: { label: " " } }, [
            _c("span", [
              _vm._v(_vm._s("*" + _vm.$t("Message.OptionIsChecked")))
            ])
          ])
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "confirm", type: "primary" },
              on: { click: _vm.confirmEditState }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }